module.exports = __webpack_public_path__ + "img/b80fe81.png";